module.exports = __webpack_public_path__ + "images/product_pickle_1.f9d10099.jpg";